import { render, staticRenderFns } from "./JSwitch.vue?vue&type=template&id=08b8f124&"
import script from "./JSwitch.vue?vue&type=script&lang=ts&"
export * from "./JSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./JSwitch.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports